import { z } from 'zod';

import { uuidValidator } from '../../validators';

export const DeleteSentencesSchema = z.object({
  ids: z
    .array(uuidValidator)
    .min(1, 'At least one sentence ID must be provided'),
});

export type IDeleteSentencesDto = z.infer<typeof DeleteSentencesSchema>;
